import type { RegionId, RegionState, StateMap } from '../types';

export function evaluate(id: RegionId, a: boolean, b = false): boolean {
  if (id === 'AND') return a && b;
  if (id === 'OR') return a || b;
  if (id === 'NAND') return !(a && b);
  return !a;
}

export function initialState(): StateMap {
  return {
    AND: makeState('AND'),
    OR: makeState('OR'),
    NAND: makeState('NAND'),
    NOT: makeState('NOT'),
  };
}

export function makeState(id: RegionId, a = false, b = false): RegionState {
  return { a, b, output: evaluate(id, a, b) };
}
